<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/priceRule/otherQuotation.js";
export default {
  components: {
    cTable,
  },
  mounted() {
    console.log(apis);
    apis.conf().then((res) => {
      console.log(res);
      this.setOptions(this.modals.add.table.fields, res.data.payload);
      this.setOptions(this.modals.add.fields, res.data.payload);
      this.setOptions(this.header.searchs, res.data.payload);
      this.conf = res.data.payload;
    });
  },
  data() {
    return {
      conf: {},
      client: [],
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                rules: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 70,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { title: 12, auto_finance: 12 },
            { type: 12, client_id: 12 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$tz("客户,类型"),
              key: "type",
              component: "Radio",
              options: [
                {
                  label: this.$tz("客户"),
                  value: 1,
                },
                {
                  label: this.$tz("分公司"),
                  value: 2,
                },
              ],
              optionsFn: "",
              optionsKey: "",
              default: 1,
              bind: {
                border: true,
              },
              methods: {
                "on-change": ({ fields, value }) => {
                  fields.forEach((field) => {
                    if (field.key === "client_id")
                      field.options =
                        value == 1
                          ? this.conf["client_id"]
                          : this.conf["ownership"];
                  });
                },
              },
            },
            {
              name: this.$tz("自动,报价"),
              key: "auto_finance",
              component: "Radio",
              options: [],
              optionsFn: "YesNoNumber2",
              optionsKey: "",
              default: 2,
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$tz("标题"),
              key: "title",
              component: "Input",
              placeholder: () => this.$tz("标题"),
            },
            {
              name: this.$tz("客户"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$tz("客户"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "",
              methods: {
                list: ({ field }) => {
                  let modal = this.$refs["table"].getModal("add");
                  if (modal.params.type === 1) {
                    field.options = this.conf["client_id"];
                  } else if (modal.params.type === 2) {
                    field.options = this.conf["ownership"];
                  }
                },
              },
            },
            {
              name: () => this.$tz("备注"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$tz("备注"),
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
          ],
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: this.$tz("科目"),
                key: "expense_item",
                component: "Select",
                placeholder: () => this.$tz("科目"),
                options: [],
                optionsFn: "",
                optionsKey: "",
                default: "",
                minWidth: 130,
              },
              {
                name: this.$tz("计费方式"),
                key: "charge_type",
                component: "Select",
                placeholder: () => this.$tz("计费方式"),
                options: [],
                optionsFn: "",
                optionsKey: "",
                default: "",
                minWidth: 110,
              },
              {
                name: () => this.$tz("计费单价"),
                key: "price",
                component: "Input",
                placeholder: () => this.$tz("计费单价"),
                minWidth: 100,
              },
              {
                name: this.$tz("计费币种"),
                key: "currency",
                component: "Select",
                placeholder: () => this.$tz("计费币种"),
                options: [],
                optionsFn: "",
                optionsKey: "",
                default: "",
                minWidth: 110,
              },
              {
                name: () => this.$tz("计费备注"),
                key: "remarks",
                component: "Input",
                placeholder: () => this.$tz("计费备注"),
                minWidth: 150,
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "success",
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "deleteFun",
                    bind: {
                      type: "error",
                    },
                    disabled() {
                      return this.$modal.list.length === 1;
                    },
                  },
                ],
                methods: {
                  add({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex + 1, 0, {});
                  },
                  deleteFun({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex, 1);
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
              id: "",
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.list.push({});
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("zhTitle"),
          key: "title",
          minWidth: 130,
        },
        {
          name: () => this.$tz("自动,报价"),
          key: "auto_finance_txt",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户类型"),
          key: "type_txt",
          minWidth: 110,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 130,
        },

        {
          name: () => this.$t("Company name"),
          key: "company",
          minWidth: 130,
        },
        {
          name: () => this.$tz("规则详情"),
          key: "rules_txt",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "edit",
              fnName: "edit",
              bind: {
                type: "primary",
              },
              id: 1661,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              id: 1660,
            },
          ],
          methods: {
            deleteFun({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            edit({ row }) {
              this.getModal("add").open(row, function () {
                this.list = row.rules;
                this.setTitle(this.$tz("编辑"));
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>